import { DesignAction, IContainerActionAttributes } from "../../../base/models";
import React, { FC } from "react";

import { ActionType } from "../../../base/types";
import { ActionsDialog } from "../../../base/register";
import { DndItem } from "../../dnd/models";
import { Droppable } from "../../dnd";
import { PageActionDesigner } from "./PageActionDesigner";
import { createAction } from "../../helpers";
import { useState } from "react";

export const DesignActionCollection: FC<IContainerActionAttributes> = ({
    actions, className, onDesignChange
}) => {
    const [dialog, showDialog] = useState<boolean>(false);
    const [targetActionId, setTargetActionId] = useState<string>()

    const onSelectAction = (actionType: ActionType) => {
        if (!targetActionId) {
            console.error(`Could't insert the new control, target control is not updated.`)
            return;
        }

        setTimeout(() => {
            const newAction = createAction(actionType)
            onDesignChange({
                type: DesignAction.InsertAfterAction,
                actionId: targetActionId,
                action: newAction
            });
        }, 50)
    }

    const onDropItem = (item: DndItem, actionId: string) => {
        if (item.type !== "Action") return;

        onDesignChange({
            type: DesignAction.DropAfterAction,
            actionId: actionId,
            action: item.action
        });
    }

    const onInsertAfter = (actionId: string) => {
        setTargetActionId(actionId)
        showDialog(true);
    }

    return <>
        {actions.slice()
            .sort((a, b) => a.sequence - b.sequence)
            .map((action) =>
                <React.Fragment key={action.actionId}>
                    <PageActionDesigner
                        action={action}
                        className={className}
                        onDesignChange={onDesignChange}>
                        <Droppable layout={"Auto"}
                            title={`Click to insert a new component`}
                            onDropItem={(item) => onDropItem(item, action.actionId)}
                            onClick={(e) => {
                                e.stopPropagation();
                                onInsertAfter(action.actionId)
                            }} />
                    </PageActionDesigner>
                </React.Fragment>)}

        <ActionsDialog
            show={dialog}
            onSelect={(type) => {
                onSelectAction(type)
            }}
            onHideModal={() => showDialog(false)}
        />
    </>
}